import type { NotificationItem } from "./types";

export enum NotificationAction {
  SET_STACK,
  ADD_STACK_ITEM,
  REMOVE_STACK_ITEM,
  NOTIFY,
  REMOVE_NOTIFICATION,
}

export interface NotificationState<D extends NotificationItem> {
  stack: D[];
  notifications: D[];
}

export type NotificationActionType<D extends NotificationItem> =
  | {
      type: NotificationAction.SET_STACK;
      payload: D[];
    }
  | {
      type: NotificationAction.ADD_STACK_ITEM;
      payload: D;
    }
  | {
      type: NotificationAction.REMOVE_STACK_ITEM;
      payload: string | number;
    }
  | {
      type: NotificationAction.NOTIFY;
      payload: D;
    }
  | {
      type: NotificationAction.REMOVE_NOTIFICATION;
      payload: string | number;
    };

export const reducer = <D extends NotificationItem>(
  state: NotificationState<D>,
  action: NotificationActionType<D>,
): NotificationState<D> => {
  switch (action.type) {
    case NotificationAction.SET_STACK:
      return { ...state, stack: action.payload };
    case NotificationAction.ADD_STACK_ITEM: {
      if (state.stack.map((s) => s.key).includes(action.payload.key)) {
        return { ...state };
      }
      return { ...state, stack: [action.payload, ...state.stack] };
    }
    case NotificationAction.REMOVE_STACK_ITEM:
      return { ...state, stack: state.stack.filter((i) => i.key !== action.payload) };
    case NotificationAction.NOTIFY:
      return { ...state, notifications: [action.payload, ...state.notifications] };
    case NotificationAction.REMOVE_NOTIFICATION:
      return { ...state, notifications: state.notifications.filter((i) => i.key !== action.payload) };
    default:
      return state;
  }
};
